import axios from 'axios';

const base = 'traffictime';

function getAll() {
    return axios.get(base);
}

function getHistorial(query = null) {
    return axios.get([base, 'historial'].join('/'), { params: query });
}

function getById(id) {
    return axios.get([base, id].join('/'));
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data.id_tt].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const TrafficTimeService = {
    getAll,
    getHistorial,
    getById,
    register,
    update,
    destroy
};

export default TrafficTimeService;
